export enum SmartCampaignObjectives {
    'Reach' = 0,
    'Traffic',
    'Engagement',
    'Lead generation',
    'Store traffic'
}
